import { render, staticRenderFns } from "./html.vue?vue&type=template&id=2595e5c4&scoped=true&"
import script from "./html.vue?vue&type=script&lang=ts&"
export * from "./html.vue?vue&type=script&lang=ts&"
import style0 from "./html.vue?vue&type=style&index=0&id=2595e5c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2595e5c4",
  null
  
)

export default component.exports